module.exports = __webpack_public_path__ + "static/media/9DESA26.ada43120.jpg";